import React from "react"
import { Typography, Button, Stack, Box, Tooltip } from "@mui/material"
import PropTypes from "prop-types"
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined"
import GridViewIcon from "@mui/icons-material/GridView"
import i18n from "i18n"
import { GRID_VIEW, CARD_VIEW } from "./constants"

const ContactsHeader = ({
  onAddNewContact,
  onOpenImport,
  viewMode,
  onViewModeChange,
}) => {
  const viewOptions = [
    {
      key: GRID_VIEW,
      icon: <GridViewIcon className="viewIcon" />,
      label: i18n.t("contacts.cardsView"),
    },
    {
      key: CARD_VIEW,
      icon: <FormatListBulletedOutlinedIcon className="viewIcon" />,
      label: i18n.t("contacts.listView"),
    },
  ]

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        width: "100%",
        marginBottom: "20px",
      }}
    >
      <Typography
        variant="h2"
        component="h2"
        sx={{
          fontWeight: 600,
          fontSize: 22,
          color: "#414141",
          fontFamily: "Helvetica",
        }}
      >
        {i18n.t("contacts.title")}
      </Typography>

      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{ display: "flex" }}>
          {viewOptions.map(({ key, icon, label }, index) => (
            <Tooltip key={key} title={label} arrow>
              <Box
                onClick={() => onViewModeChange(key)}
                onKeyDown={event => {
                  if (event.key === "Enter" || event.key === " ") {
                    if (event.key === " ") {
                      event.preventDefault()
                    }
                    onViewModeChange(key)
                  }
                }}
                aria-label={label}
                aria-pressed={viewMode === key}
                role="button"
                tabIndex={0}
                sx={{
                  cursor: "pointer",
                  padding: "8px",
                  borderRadius: index === 0 ? "6px 0 0 6px" : "0 6px 6px 0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "40px",
                  height: "40px",
                  marginLeft: "0px",
                  transition: "all 0.2s ease-in-out",
                  backgroundColor: viewMode === key ? "#ffd52b" : "#f9e896",
                  color: "#414141",
                  opacity: viewMode === key ? 1 : 0.5,
                  "&:hover": {
                    backgroundColor: viewMode === key ? "#ffd52b" : "#ffe992",
                  },
                  "& .viewIcon": {
                    fontSize: "20px",
                  },
                }}
              >
                {icon}
              </Box>
            </Tooltip>
          ))}
        </Box>

        <Button variant="outlined" color="branded" onClick={onOpenImport}>
          {i18n.t("contacts.importFromExcel")}
        </Button>
        <Button variant="contained" color="branded" onClick={onAddNewContact}>
          {i18n.t("contacts.newContact")}
        </Button>
      </Stack>
    </Stack>
  )
}

ContactsHeader.propTypes = {
  onAddNewContact: PropTypes.func.isRequired,
  onOpenImport: PropTypes.func.isRequired,
  viewMode: PropTypes.number.isRequired,
  onViewModeChange: PropTypes.func.isRequired,
}

export default ContactsHeader
